var React = require('react');

function XInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#1C3133","key":0}),React.createElement("path",{"d":"M13.5284 11.5959L18.1935 6H16.0905L12.5348 10.2651L9.34981 6H5L10.2403 13.0174L5.31676 18.9231H7.41977L11.2339 14.3482L14.6502 18.9231H19L13.5284 11.5959ZM16.4021 17.6523H15.2707C15.2488 17.6523 15.2283 17.6418 15.215 17.6242L12.052 13.367L11.061 12.033L7.52314 7.27164C7.48849 7.2251 7.52141 7.15835 7.57887 7.15835H8.71021C8.73187 7.15835 8.75266 7.16889 8.76594 7.18645L11.7514 11.2048L12.7424 12.5385L16.4578 17.539C16.4925 17.5856 16.4595 17.6523 16.4021 17.6523Z","fill":"white","key":1})]);
}

XInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = XInline;

XInline.default = XInline;
